/*
 * Copyright 2019-2021 Motorola Solutions, Inc.
 * All Rights Reserved.
 * Motorola Solutions Confidential Restricted
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfirmAuthGuardService } from '@msi/commandcentral-common-header';
import { UserService } from '@services/user.service';
import { TemplateConstants } from '@constants/template-constants';

export function roleGuard(allowedRoles: string[]): CanActivateFn {
  return (route, state) => {
    const confirmAuthGuardService: ConfirmAuthGuardService = inject(ConfirmAuthGuardService);
    const router = inject(Router);

    if (!confirmAuthGuardService.isAuthenticated()) {
      return router.createUrlTree(['/unauthorized']);

    }
    return true;
    // For now this unforcement isn't necessary, but we will need a bootstrap function to call some API endpoints prior to AppComponent loading for it to work seamlessly
    const userService: UserService = inject(UserService);
    let authenticated: boolean = false;

    if (allowedRoles.includes(TemplateConstants.QueryPermissionName)) {
      authenticated ||= userService.hasQueryPermissions();
    }
    if (allowedRoles.includes(TemplateConstants.CommandPermissionName)) {
      authenticated ||= userService.hasCommandPermissions();
    }
    if (allowedRoles.includes(TemplateConstants.UploadPermissionName)) {
      authenticated ||= userService.hasUploadPermissions();
    }
    if (allowedRoles.includes(TemplateConstants.AdminPermissionName)) {
      authenticated ||= userService.hasAdminPermissions();
    }

    if (!authenticated) {
      return router.createUrlTree(['/unauthorized']);
    }

    return authenticated;
  };
}
